var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIls1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.231,
    height: 303.308,
    viewBox: "0 0 274.231 303.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M234.083,253.317c-2.642-.272-5.859,1.728-8.246,1.425-5.613-.707-5.891-4.923-8.731-8.336a11.388,11.388,0,0,0-8.969-4.244,12.052,12.052,0,0,0-9.661,5.8,54.645,54.645,0,0,0-2.753,6.113c-1.926,3.638-.136,2.044-4.6,6.283-4.8,4.559-3.783,3.238-8.633,1.027-6.9-3.139-15.509-1.783-15.056,7.238a8.457,8.457,0,0,0,.679,5.74c2.752,5.694,9.033,10.683,13.175,15.36,4.587,5.18,9.238,12.453,15.546,15.71,9.13,4.715,23.659,3.139,31.785-2.895C239.342,294.563,259,255.885,234.083,253.317Z",
    transform: "translate(-167.211 -242.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M214.092,257.148c-2.568-7.286-10.395-3.36-13,1.353a33.37,33.37,0,0,0-2.518,8.423c-.762,3.241.341,6.265-2.34,2.913-3.452-4.32-2.536-10.964-5.926-15.516-3.995-5.364-9.457-4.465-10.172,2.3-.707,6.674,3.28,12.091,4.113,18.287a35.363,35.363,0,0,0,1.554,3.28,2.8,2.8,0,0,1-4.173-1.574c-2.3-1.447-3.86-3.961-6.306-5.351-5.355-3.043-13.086-2.6-11.141,5.521,2.741,11.392,21.783,20.63,31.124,25.125a.051.051,0,0,1,.034.009c3.83,2.044,7.781,1,10.61-4.64,3.417-6.83,3.986-15.64,5.415-23.049C212.168,270.083,215.636,261.528,214.092,257.148Z",
    transform: "translate(-163.882 -250.843)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M253.142,274.163c-9.854-2.98-19.854.255-28.446,5.952,4.932-7.346,10.195-14.5,13.376-22.908,1.174-3.1-2.582-4.844-4.966-3.85-9.123,3.8-13.793,10.964-17.263,19.07a45.343,45.343,0,0,0-5.42-19.96c-1.579-2.852-6.61-1.768-6.356,1.694.617,8.393,1.093,16.8,1.5,25.2-6.437-4.791-16.216-6.957-22.623-5.321a3.443,3.443,0,0,0-.856,6.211A111.257,111.257,0,0,1,203.4,298.061a3.72,3.72,0,0,0,.424.371,9.712,9.712,0,0,0,9.471,4.488c5.6-.444,11.307-5.045,15.873-7.765L253.931,280.4a3.44,3.44,0,0,0-.789-6.234Z",
    transform: "translate(-180.486 -250.834)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M138.083,253.317c-2.642-.272-5.859,1.728-8.246,1.425-5.613-.707-5.891-4.923-8.731-8.336a11.388,11.388,0,0,0-8.969-4.244,12.052,12.052,0,0,0-9.661,5.8,54.642,54.642,0,0,0-2.753,6.113c-1.926,3.638-.136,2.044-4.6,6.283-4.8,4.559-3.783,3.238-8.633,1.027-6.9-3.139-15.509-1.783-15.056,7.238a8.456,8.456,0,0,0,.679,5.74c2.752,5.694,9.033,10.683,13.175,15.36,4.587,5.18,9.238,12.453,15.546,15.71,9.13,4.715,23.659,3.139,31.785-2.895C143.342,294.563,163,255.885,138.083,253.317Z",
    transform: "translate(-71.211 -242.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M118.092,257.148c-2.568-7.286-10.395-3.36-13,1.353a33.368,33.368,0,0,0-2.518,8.423c-.762,3.242.341,6.265-2.34,2.913-3.452-4.32-2.536-10.964-5.926-15.516-3.995-5.364-9.457-4.465-10.172,2.3-.707,6.674,3.28,12.091,4.113,18.287a35.37,35.37,0,0,0,1.554,3.28,2.8,2.8,0,0,1-4.173-1.574c-2.3-1.447-3.86-3.961-6.306-5.351-5.355-3.043-13.086-2.6-11.141,5.521,2.741,11.392,21.783,20.63,31.124,25.125a.051.051,0,0,1,.034.009c3.83,2.044,7.781,1,10.61-4.64,3.417-6.83,3.986-15.64,5.415-23.049C116.168,270.083,119.636,261.528,118.092,257.148Z",
    transform: "translate(-67.881 -250.843)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M157.142,274.163c-9.853-2.98-19.854.255-28.446,5.952,4.932-7.346,10.195-14.5,13.376-22.908,1.174-3.1-2.582-4.844-4.966-3.85-9.123,3.8-13.793,10.964-17.263,19.07a45.343,45.343,0,0,0-5.42-19.96c-1.579-2.852-6.61-1.768-6.356,1.694.617,8.393,1.093,16.8,1.5,25.2-6.437-4.791-16.216-6.957-22.623-5.321a3.443,3.443,0,0,0-.856,6.211A111.255,111.255,0,0,1,107.4,298.061a3.718,3.718,0,0,0,.424.371,9.712,9.712,0,0,0,9.472,4.488c5.6-.444,11.307-5.045,15.873-7.765L157.922,280.4a3.439,3.439,0,0,0-.78-6.234Z",
    transform: "translate(-84.486 -250.834)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature-ils-1",
    transform: "translate(-67.881 -118.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M117.295,381.812c-43.907-46.824-48.023-72.359-41.853-87.242,8.593-20.729,37.158-20.848,43.03-44.8,5.128-20.9-13.793-32.3-10.61-56,2.486-18.489,16-41.124,33.011-43.619,24.559-3.6,35.258,37.909,67.2,37.725,20.842-.12,26.823-17.861,48.336-14.736,12.814,1.857,28.627,10.75,33.6,24.758,7.735,21.785-17.33,37.432-10.02,58.357,6.013,17.219,25.582,14.036,35.368,30.063,15.175,24.851-6.745,73.659-35.958,97.851Z",
    transform: "translate(4.068 37.299)",
    fill: "#feae5e",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(237.647 350.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(5.888 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M234.083,253.317c-2.642-.272-5.859,1.728-8.246,1.425-5.613-.707-5.891-4.923-8.731-8.336a11.388,11.388,0,0,0-8.969-4.244,12.052,12.052,0,0,0-9.661,5.8,54.645,54.645,0,0,0-2.753,6.113c-1.926,3.638-.136,2.044-4.6,6.283-4.8,4.559-3.783,3.238-8.633,1.027-6.9-3.139-15.509-1.783-15.056,7.238a8.457,8.457,0,0,0,.679,5.74c2.752,5.694,9.033,10.683,13.175,15.36,4.587,5.18,9.238,12.453,15.546,15.71,9.13,4.715,23.659,3.139,31.785-2.895C239.342,294.563,259,255.885,234.083,253.317Z",
    transform: "translate(-167.211 -242.162)",
    fill: "#b3d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M201.568,296.282c-4.92-7.733-9.809-15.488-14.759-23.2-3.565-5.555-7.279-10.739-12.747-14.57-1.2-.838-2.333,1.126-1.146,1.958,6.294,4.409,10.158,10.964,14.206,17.33l12.488,19.629C200.4,298.653,202.362,297.518,201.568,296.282Z",
    transform: "translate(-163.213 -229.756)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M190.83,251.345a1.134,1.134,0,0,0-2.267,0q-.437,26.466.966,52.9c.076,1.452,2.345,1.461,2.267,0Q190.393,277.816,190.83,251.345Z",
    transform: "translate(-150.884 -235.977)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M212.317,258.332c-8.262,12.5-13.931,26.439-21.557,39.311a1.134,1.134,0,0,0,1.958,1.144c7.625-12.872,13.295-26.807,21.557-39.311C215.081,258.256,213.118,257.117,212.317,258.332Z",
    transform: "translate(-149.235 -230.136)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M168.608,265.277s16.446,13.746,37.412,13.746S247.257,260.6,247.257,260.6v33.585H168.033Z",
    transform: "translate(-166.579 -227.994)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M214.092,257.148c-2.568-7.286-10.395-3.36-13,1.353a33.37,33.37,0,0,0-2.518,8.423c-.762,3.241.341,6.265-2.34,2.913-3.452-4.32-2.536-10.964-5.926-15.516-3.995-5.364-9.457-4.465-10.172,2.3-.707,6.674,3.28,12.091,4.113,18.287a35.363,35.363,0,0,0,1.554,3.28,2.8,2.8,0,0,1-4.173-1.574c-2.3-1.447-3.86-3.961-6.306-5.351-5.355-3.043-13.086-2.6-11.141,5.521,2.741,11.392,21.783,20.63,31.124,25.125a.051.051,0,0,1,.034.009c3.83,2.044,7.781,1,10.61-4.64,3.417-6.83,3.986-15.64,5.415-23.049C212.168,270.083,215.636,261.528,214.092,257.148Z",
    transform: "translate(-163.882 -250.843)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M205.294,257.223c.477-1.381-1.712-1.975-2.186-.6-4.051,11.763-5.1,24.011-5.523,36.326-1.438-3.563-3.07-7.052-4.511-10.628A194.292,194.292,0,0,1,186,261.169a1.135,1.135,0,0,0-2.188.6,195.2,195.2,0,0,0,7.074,21.15c1.627,4.044,3.512,7.988,5.072,12.05A141.751,141.751,0,0,0,170.183,273.9c-1.238-.789-2.373,1.174-1.144,1.958A139.463,139.463,0,0,1,197.39,299.82c0,.262-.014.53-.019.783a1,1,0,0,0,.723,1.031c.028.117.065.232.092.354.334,1.415,2.522.819,2.188-.6-.08-.34-.177-.668-.271-1a1.091,1.091,0,0,0-.2-1.176c-.051-.058-.106-.113-.159-.177-.021-.072-.037-.147-.058-.219C200.009,284.734,200.667,270.66,205.294,257.223Z",
    transform: "translate(-160.325 -247.001)",
    fill: "#6cd3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M165.152,270.115s14.6,9.5,22.812,9.5,21.965-7.227,25.934-13.321v28.489h-48.32Z",
    transform: "translate(-162.905 -238.973)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(29.363 15.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M253.142,274.163c-9.854-2.98-19.854.255-28.446,5.952,4.932-7.346,10.195-14.5,13.376-22.908,1.174-3.1-2.582-4.844-4.966-3.85-9.123,3.8-13.793,10.964-17.263,19.07a45.343,45.343,0,0,0-5.42-19.96c-1.579-2.852-6.61-1.768-6.356,1.694.617,8.393,1.093,16.8,1.5,25.2-6.437-4.791-16.216-6.957-22.623-5.321a3.443,3.443,0,0,0-.856,6.211A111.257,111.257,0,0,1,203.4,298.061a3.72,3.72,0,0,0,.424.371,9.712,9.712,0,0,0,9.471,4.488c5.6-.444,11.307-5.045,15.873-7.765L253.931,280.4a3.44,3.44,0,0,0-.789-6.234Z",
    transform: "translate(-180.486 -250.834)",
    fill: "#5db3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M229.32,275.044a74.338,74.338,0,0,0-20.971,16.122q6.159-14.8,12.317-29.6c.559-1.344-1.632-1.929-2.187-.6L206.6,289.525q.088-13.661-.928-27.3c-.108-1.447-2.377-1.457-2.269,0q1.061,14.239.905,28.5c-2.764-7.643-7.349-14.444-15.217-17.82-1.325-.568-2.5,1.376-1.158,1.945,9.111,3.908,13.44,12.511,15.774,21.617v.016a.884.884,0,0,0-.032.377c-.575.773-1.162,1.535-1.712,2.331-.829,1.2,1.126,2.354,1.945,1.158.226-.327.472-.631.707-.955a1.162,1.162,0,0,0,1.814-.9c.018-.53.025-1.077.032-1.616a72.122,72.122,0,0,1,23.994-19.879C231.742,276.335,230.614,274.368,229.32,275.044Z",
    transform: "translate(-175.221 -243.627)",
    fill: "#71d7e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M184.828,269.816s11.622,9.068,23.52,9.068,29.9-4.393,29.9-4.393v14.03h-53.7Z",
    transform: "translate(-177.367 -236.249)",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(67.881 350.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(5.888 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M138.083,253.317c-2.642-.272-5.859,1.728-8.246,1.425-5.613-.707-5.891-4.923-8.731-8.336a11.388,11.388,0,0,0-8.969-4.244,12.052,12.052,0,0,0-9.661,5.8,54.642,54.642,0,0,0-2.753,6.113c-1.926,3.638-.136,2.044-4.6,6.283-4.8,4.559-3.783,3.238-8.633,1.027-6.9-3.139-15.509-1.783-15.056,7.238a8.456,8.456,0,0,0,.679,5.74c2.752,5.694,9.033,10.683,13.175,15.36,4.587,5.18,9.238,12.453,15.546,15.71,9.13,4.715,23.659,3.139,31.785-2.895C143.342,294.563,163,255.885,138.083,253.317Z",
    transform: "translate(-71.211 -242.162)",
    fill: "#b3d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M105.568,296.282c-4.92-7.733-9.809-15.488-14.759-23.2-3.565-5.555-7.279-10.739-12.747-14.57-1.2-.838-2.333,1.126-1.146,1.958,6.294,4.409,10.158,10.964,14.206,17.33l12.488,19.629C104.4,298.653,106.362,297.518,105.568,296.282Z",
    transform: "translate(-67.213 -229.756)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M94.83,251.345a1.134,1.134,0,0,0-2.267,0q-.439,26.466.966,52.9c.076,1.452,2.345,1.461,2.267,0Q94.4,277.816,94.83,251.345Z",
    transform: "translate(-54.884 -235.977)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M116.317,258.332c-8.262,12.5-13.931,26.439-21.557,39.311a1.134,1.134,0,0,0,1.958,1.144c7.625-12.872,13.295-26.807,21.557-39.311C119.081,258.256,117.118,257.117,116.317,258.332Z",
    transform: "translate(-53.235 -230.136)",
    fill: "#d2f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M72.608,265.277s16.446,13.746,37.412,13.746S151.257,260.6,151.257,260.6v33.585H72.033Z",
    transform: "translate(-70.579 -227.994)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M118.092,257.148c-2.568-7.286-10.395-3.36-13,1.353a33.368,33.368,0,0,0-2.518,8.423c-.762,3.242.341,6.265-2.34,2.913-3.452-4.32-2.536-10.964-5.926-15.516-3.995-5.364-9.457-4.465-10.172,2.3-.707,6.674,3.28,12.091,4.113,18.287a35.37,35.37,0,0,0,1.554,3.28,2.8,2.8,0,0,1-4.173-1.574c-2.3-1.447-3.86-3.961-6.306-5.351-5.355-3.043-13.086-2.6-11.141,5.521,2.741,11.392,21.783,20.63,31.124,25.125a.051.051,0,0,1,.034.009c3.83,2.044,7.781,1,10.61-4.64,3.417-6.83,3.986-15.64,5.415-23.049C116.168,270.083,119.636,261.528,118.092,257.148Z",
    transform: "translate(-67.881 -250.843)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M109.294,257.223c.477-1.381-1.712-1.975-2.186-.6-4.051,11.763-5.1,24.011-5.523,36.326-1.438-3.563-3.07-7.052-4.511-10.628A194.288,194.288,0,0,1,90,261.169a1.135,1.135,0,0,0-2.188.6,195.2,195.2,0,0,0,7.074,21.15c1.627,4.044,3.512,7.988,5.072,12.05A141.689,141.689,0,0,0,74.183,273.9c-1.238-.789-2.373,1.174-1.144,1.958A139.461,139.461,0,0,1,101.39,299.82c0,.262-.014.53-.019.783a1,1,0,0,0,.723,1.031c.028.117.065.232.092.354.334,1.415,2.522.819,2.188-.6-.08-.34-.177-.668-.271-1a1.091,1.091,0,0,0-.2-1.176c-.051-.058-.106-.113-.159-.177-.021-.072-.037-.147-.058-.219C104.009,284.734,104.667,270.66,109.294,257.223Z",
    transform: "translate(-64.325 -247.001)",
    fill: "#6cd3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M69.153,270.115s14.595,9.5,22.812,9.5,21.965-7.227,25.934-13.321v28.489H69.577Z",
    transform: "translate(-66.904 -238.973)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(29.363 15.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M157.142,274.163c-9.853-2.98-19.854.255-28.446,5.952,4.932-7.346,10.195-14.5,13.376-22.908,1.174-3.1-2.582-4.844-4.966-3.85-9.123,3.8-13.793,10.964-17.263,19.07a45.343,45.343,0,0,0-5.42-19.96c-1.579-2.852-6.61-1.768-6.356,1.694.617,8.393,1.093,16.8,1.5,25.2-6.437-4.791-16.216-6.957-22.623-5.321a3.443,3.443,0,0,0-.856,6.211A111.255,111.255,0,0,1,107.4,298.061a3.718,3.718,0,0,0,.424.371,9.712,9.712,0,0,0,9.472,4.488c5.6-.444,11.307-5.045,15.873-7.765L157.922,280.4a3.439,3.439,0,0,0-.78-6.234Z",
    transform: "translate(-84.486 -250.834)",
    fill: "#5db3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M133.316,275.044a74.338,74.338,0,0,0-20.971,16.122q6.159-14.8,12.317-29.6c.561-1.344-1.632-1.929-2.187-.6l-11.882,28.56q.088-13.661-.928-27.3c-.108-1.447-2.377-1.457-2.269,0q1.061,14.239.905,28.5c-2.764-7.643-7.349-14.444-15.208-17.82-1.325-.568-2.5,1.376-1.158,1.945,9.111,3.908,13.44,12.511,15.774,21.617v.016a.885.885,0,0,0-.032.377c-.575.773-1.162,1.535-1.712,2.331-.829,1.2,1.126,2.354,1.945,1.158.226-.327.472-.631.707-.955a1.162,1.162,0,0,0,1.814-.9c.018-.53.025-1.077.032-1.616a72.123,72.123,0,0,1,23.994-19.879C135.739,276.335,134.61,274.368,133.316,275.044Z",
    transform: "translate(-79.217 -243.627)",
    fill: "#71d7e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M88.83,269.816s11.62,9.068,23.52,9.068,29.9-4.393,29.9-4.393v14.03H88.545Z",
    transform: "translate(-81.367 -236.249)",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M292.372,285.463H87.827a3.537,3.537,0,0,1-3.537-3.537h0a3.537,3.537,0,0,1,3.537-3.537H292.372a3.537,3.537,0,0,1,3.537,3.537h0A3.537,3.537,0,0,1,292.372,285.463Z",
    transform: "translate(12.608 136.006)",
    fill: "#5db3c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(103.53 101.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(95.736 16.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 121.83,
    height: 179.845,
    rx: 11.833,
    fill: "rgba(96,168,226,0.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 105.67,
    height: 164.927,
    rx: 6.083,
    transform: "translate(8.08 7.458)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 21.966,
    height: 21.966,
    rx: 3,
    transform: "translate(20.303 28.859)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 21.966,
    height: 21.966,
    rx: 3,
    transform: "translate(20.303 55.94)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 21.966,
    height: 21.966,
    rx: 3,
    transform: "translate(20.303 83.022)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M216.547,117.547H179.666c-1.373,0-2.486-.754-2.486-1.684h0c0-.93,1.112-1.685,2.486-1.685h36.881c1.374,0,2.487.754,2.486,1.685h0C219.033,116.793,217.92,117.547,216.547,117.547Z",
    transform: "translate(-129.412 -81.433)",
    fill: "#fcc084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-2",
    "data-name": "Path 284",
    d: "M216.547,117.547H179.666c-1.373,0-2.486-.754-2.486-1.684h0c0-.93,1.112-1.685,2.486-1.685h36.881c1.374,0,2.487.754,2.486,1.685h0C219.033,116.793,217.92,117.547,216.547,117.547Z",
    transform: "translate(-129.412 -53.047)",
    fill: "#fcc084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-3",
    "data-name": "Path 284",
    d: "M216.547,117.547H179.666c-1.373,0-2.486-.754-2.486-1.684h0c0-.93,1.112-1.685,2.486-1.685h36.881c1.374,0,2.487.754,2.486,1.685h0C219.033,116.793,217.92,117.547,216.547,117.547Z",
    transform: "translate(-129.412 -28.047)",
    fill: "#fcc084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M227.154,187.611h-77.5c-1.307,0-2.366-.427-2.366-.954h0c0-.527,1.059-.954,2.366-.954h77.5c1.307,0,2.366.427,2.366.954h0C229.52,187.184,228.461,187.611,227.154,187.611Z",
    transform: "translate(-126.988 -73.039)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "translate(47.768 44.938)",
    fill: "#8bd8ea",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "$",
    transform: "translate(47.768 73.324)",
    fill: "#8bd8ea",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "$",
    transform: "translate(47.768 98.324)",
    fill: "#8bd8ea",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": "$",
    transform: "translate(57.714 44.938)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": "$",
    transform: "translate(57.714 73.324)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": "$",
    transform: "translate(57.714 98.324)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": "$",
    transform: "translate(67.66 44.938)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": "$",
    transform: "translate(67.66 73.324)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": "$",
    transform: "translate(67.66 98.324)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": "$",
    transform: "translate(62.695 147.857)",
    fill: "#8bd8ea",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_11",
    "data-name": "$",
    transform: "translate(72.64 147.857)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": "$",
    transform: "translate(82.586 147.857)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_13",
    "data-name": "$",
    transform: "translate(92.531 147.857)",
    fill: "#f6ca7f",
    fontSize: 10,
    fontFamily: "Webdings"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(20.303 141.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M154.156,198.943v-2.89h-4.781v1.075h3.705v8.5h11.639l2.471-6.677Z",
    transform: "translate(-149.375 -196.053)",
    fill: "#8bd8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M154.557,203.7a.866.866,0,1,1-.866-.867A.866.866,0,0,1,154.557,203.7Z",
    transform: "translate(-147.683 -192.728)",
    fill: "#8bd8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M159.212,203.7a.867.867,0,1,1-.867-.867A.867.867,0,0,1,159.212,203.7Z",
    transform: "translate(-145.402 -192.728)",
    fill: "#8bd8ea"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M155.764,122.325l-2.349-2.821-1.6,1.333,2.349,2.821,1.333,1.6,1.6-1.333,5.389-4.485-1.333-1.6Z",
    transform: "translate(-125.864 -81.709)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M155.764,147.348l-2.349-2.821-1.6,1.333,2.349,2.821,1.333,1.6,1.6-1.334,5.389-4.485-1.333-1.6Z",
    transform: "translate(-125.864 -79.65)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M155.764,172.371l-2.349-2.821-1.6,1.333,2.349,2.821,1.333,1.6,1.6-1.333,5.389-4.485-1.333-1.6Z",
    transform: "translate(-125.864 -77.591)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 71.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M205.77,272.1c-1.848-1.966-3.577-4.028-5.438-5.982-11.751-12.393-23.873-24.429-36.215-36.217-.96-.913-1.979-1.729-2.95-2.617-.782-.707-.794-1.043-.143-1.8.214-.248.474-.449.707-.674,1.956-1.85,3.933-3.673,5.864-5.546.653-.615,1.2-1.339,1.79-2-.071-.141-.131-.3-.2-.439-.769-.048-1.551-.106-2.322-.166-2.748-.177-5.521-.26-8.257-.545-5.616-.592-11.219-1.326-16.835-1.931s-11.123-1.823-16.692-2.76c-2.914-.485-3.537-.936-2.808,2.844a10.266,10.266,0,0,1-.4,6.517,48.705,48.705,0,0,0-2.736,8.311,3.632,3.632,0,0,0-1.852-.016l.218-.849c-.336.373-.64.76-.944,1.148a3.7,3.7,0,0,0-1.533,1.708c-.168.354-.308.707-.467,1.061-3.627,5.305-7.341,10.559-10.787,15.977-4.311,6.741-8.375,13.648-12.522,20.5-1.729,2.854-1.717,3.091.6,5.6,3.684,4.016,7.415,7.984,11.141,11.965.071.083.225.106.686.331.014-.065.028-.131.041-.2a4.444,4.444,0,0,0,1.715.515q-.684,3.409-1.363,6.815c-.937,4.633-1.873,9.254-2.737,13.9-1.238,6.633-2.405,13.279-3.613,19.914-.285,1.563-.3,1.623,1.415,1.671,4.336.141,8.665.308,13.008.318,17.307.037,34.616.012,51.913.012,2.76,0,5.532,0,8.292.012,5.461.035,10.911.094,16.372.106,1.565.012,1.636-.118,1.238-1.563-1.592-5.745-3.151-11.495-4.762-17.237-.746-2.644-1.576-5.261-2.428-8.092-.6.531-.973.884-1.374,1.2-1.079.852-1.592.757-2.357-.451a5.09,5.09,0,0,1-.249-.531,215.4,215.4,0,0,1-9.988-20.485c-1.694-3.837-3.36-7.687-5.045-11.526-.249-.557-.522-1.149.189-1.516s1.089.129,1.362.721c.439.948.913,1.885,1.316,2.856,3.436,8.292,7.12,16.49,11.141,24.522.769,1.565,1.682,3.068,2.653,4.8.568-.638.948-1.061,1.326-1.48,2.653-2.9,5.141-5.97,7.984-8.665A169.192,169.192,0,0,0,203.31,277.6c.925-1.1,1.768-2.274,2.63-3.448a1.443,1.443,0,0,0-.17-2.044Z",
    transform: "translate(-86.521 -88.655)",
    fill: "#ffbd5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M197.656,188.544c.734,4.478-.177,8.909-.32,13.362-.106,3.282-.368,6.552-.58,9.834-.131,2.025-.285,4.039-.439,6.159a9.368,9.368,0,0,0-1.172-.354c-.937-.141-1.114-.734-1.043-1.563q.515-6.379.983-12.759c.071-.983.048-1.979.106-2.962.226-3.471.463-6.941.688-10.412a8.057,8.057,0,0,0-.035-1.777,1.821,1.821,0,0,0-1.493-1.623c-.451-.1-.9-.214-1.351-.272-1.768-.214-3.519-.416-5.284-.592-1.493-.154-1.623-.048-2.143,1.326a6.168,6.168,0,0,1-.38.912,1.933,1.933,0,0,1-1.74,1.089c-.842-.011-1.256-.638-1.592-1.291a3.019,3.019,0,0,1-.166-.568c-.52-1.873-.663-2.014-2.5-2.039-2.168-.035-4.348-.035-6.517,0a2.539,2.539,0,0,0-2.829,2.4c-.272,1.415-.474,2.856-.615,4.288-.64,6.529-1.3,13.068-1.873,19.608-.343,3.991-.52,8-.769,12-.118,1.966-.285,3.933-.32,5.9-.035,1.8.249,2.274,2,2.571,2.062.343,4.17.439,6.255.592,2.216.154,4.432.249,6.872.378-.354,1.114-.6,1.729-1.682,1.719a62.469,62.469,0,0,1-12.156-1.043c-.189-.048-.391-.058-.58-.118-2.2-.628-2.808-1.326-2.7-3.59.177-3.814.486-7.6.759-11.408.177-2.546.343-5.105.592-7.654.285-2.879.653-5.733.973-8.612.071-.653.106-1.3.141-1.956a74.67,74.67,0,0,1,2.3-14.559c.52-1.989,1.042-2.488,3.151-2.524a79.212,79.212,0,0,1,8.861.154c4.442.391,8.872.983,13.279,1.646C196.637,185.167,197.277,186.2,197.656,188.544Z",
    transform: "translate(-29.466 -110.287)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M191.244,186.258c.935.058,1.291.414,1.238,1.326-.118,2.3-.177,4.6-.3,6.9-.06,1.238-.214,2.488-.3,3.731-.3,4.787-.568,9.572-.865,14.359-.011.189,0,.391-.023.592-.189,1.931-.189,1.86-2.085,1.979a12.444,12.444,0,0,0-3.448.592,3.236,3.236,0,0,0-1.823,4.525,10.391,10.391,0,0,0,3.341,3.79c.332.285.688.531,1.316,1.02a12.522,12.522,0,0,0-6.529,3.767,2.069,2.069,0,0,1-1.385.474c-1.376.035-2.76-.012-4.136-.071-2.239-.1-4.465-.226-6.693-.332-.129-.012-.26-.012-.391-.023-2.713-.166-2.937-.345-2.771-3,.308-4.775.676-9.549,1.042-14.335.262-3.537.5-7.074.842-10.591.486-4.835,1.061-9.655,1.592-14.478.143-1.208.285-1.339,1.482-1.362,1.906-.048,3.814-.012,5.721-.025.628-.011,1.139.048,1.268.842a3.627,3.627,0,0,0,.569,1.256,3.28,3.28,0,0,0,3.056,1.825,3.349,3.349,0,0,0,3.222-2.18c.32-1.061.884-1.149,1.742-1.042C188.377,185.973,189.81,186.174,191.244,186.258Z",
    transform: "translate(-27.864 -108.641)",
    fill: "#ffedd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M195.533,160.28c1.042.842.9,2.2.686,3.484a19.1,19.1,0,0,1-3.89,7.866,48.2,48.2,0,0,1-7.3,7.7,82.614,82.614,0,0,1-22.165,14.1,51.612,51.612,0,0,1-16.23,4.515c-2.027.189-4.051.426-6.078.628a1.995,1.995,0,0,0-2.025,2.156c-.237,3.006-.428,6.03-.653,9.04-.083,1.019-.214,2.037-.354,3.293-.817-.58-1.386-1-1.966-1.4a10.453,10.453,0,0,0-14.193,2.7,10.331,10.331,0,0,0-1.989,8.311c1.006,5.659,4.621,8.612,9.749,10.165a35.643,35.643,0,0,0,4.067.734c1.126.189,1.238.32.925,1.415-.707,2.453-1.415,4.918-2.193,7.358-.911,2.867-1.906,5.71-2.867,8.564-.118.378-.32.723-.414,1.1-.214.817-.663.983-1.47.806a42.5,42.5,0,0,1-11.848-4.692,38.265,38.265,0,0,1-13.162-12.771,32.892,32.892,0,0,1-4.573-12.06,34.661,34.661,0,0,1-.378-11.171,26.666,26.666,0,0,1,4.893-12.925,20.915,20.915,0,0,1,14.725-8.529,25.98,25.98,0,0,1,7.25-.048,3.12,3.12,0,0,0,1.945-.707,128.7,128.7,0,0,0,31.762-30.874c2.63-3.613,5.249-7.226,7.914-10.787a12.6,12.6,0,0,1,7.286-5.07,16.461,16.461,0,0,1,3.89-.285,3.132,3.132,0,0,1,2.559,1.636,6.367,6.367,0,0,1,.935,5.448c-.166.557-.378,1.126.2,1.363a2.087,2.087,0,0,0,1.415-.189c.913-.368,1.754-.9,2.667-1.238a4.674,4.674,0,0,1,5.947,5.332,8.743,8.743,0,0,1-2.264,4.928c-.391.343-.829.817-.426,1.362.439.557,1.061.38,1.623.106.817-.414,1.634-.84,2.451-1.238A3.22,3.22,0,0,1,195.533,160.28Z",
    transform: "translate(-81.21 -141.08)",
    fill: "#4f9ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M144.227,179.134a88.6,88.6,0,0,1-.071,8.861,17.422,17.422,0,0,1-5.095,10.828,14.168,14.168,0,0,1-1.634,1.185c-.071-1.3-.154-2.262-.166-3.222a109.544,109.544,0,0,0-2.143-17.557c-.214-1.208-.226-1.238.936-1.3,2.168-.118,4.336-.237,6.5-.285C144.085,177.618,144.216,177.712,144.227,179.134Z",
    transform: "translate(-51.952 -114.371)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M212.258,205.584a11.7,11.7,0,0,0-9.466-2.322,1.692,1.692,0,0,0-1.54,2.4,3.767,3.767,0,0,0,.884,1.493,14.37,14.37,0,0,0,4.6,3.328,5.46,5.46,0,0,1,1.339.806,1.415,1.415,0,0,1,.237,1.061c-.048.2-.474.391-.759.451-.378.094-.794,0-1.172.071a18.389,18.389,0,0,0-3.638.769,11.848,11.848,0,0,0-6.776,7.958c-.177.569-.3,1.149-.474,1.706-.141.5-.509.913-.983.663a1.356,1.356,0,0,1-.509-1.089c.071-2.11.1-2.11-1.906-2.228-.531-.035-1.061,0-1.577-.046-2.95-.272-5.91-.416-8.824-.865-3.756-.569-5.142-2.44-4.881-6.257.141-2.025.391-4.051.555-6.076.083-.884.108-1.742.156-2.607-.143-.048-.285-.083-.416-.131-.782,1.185-1.623,2.345-2.334,3.567a9.466,9.466,0,0,0-1.172,6.076,25.773,25.773,0,0,0,2.309,7.689c1.659,3.565,3.247,7.167,4.918,10.722a3.022,3.022,0,0,1-.166,2.985c-1.061,1.883-2.062,3.814-3.116,5.7-3.933,7.049-7.855,14.1-11.848,21.111-1.848,3.247-3.852,6.41-5.783,9.62,1.316,1.517,2.607,3.006,3.91,4.479,2.31,2.617,2.322,2.688.262,5.482-.118.164-.237.318-.354.485A135.442,135.442,0,0,1,147.9,299.85c-.8.734-1.528,1.576-2.31,2.382a3.906,3.906,0,0,0,.509.53c3.164,2,6.315,4,9.514,5.959a18.742,18.742,0,0,0,3.006,1.432,3.537,3.537,0,0,0,4.928-1.5,17.509,17.509,0,0,0,.936-1.5c1.457-2.785,2.927-5.569,4.348-8.365,2.156-4.218,4.384-8.4,6.366-12.676,3.91-8.388,7.618-16.87,11.539-25.246,3.537-7.535,7.535-14.869,10.283-22.757a5.542,5.542,0,0,1,1.238-1.966c2.463-2.548,5-5.036,7.486-7.56a39.966,39.966,0,0,0,6.86-8.842,15.584,15.584,0,0,0,2.311-8.435A7.349,7.349,0,0,0,212.258,205.584Z",
    transform: "translate(-43.819 -94.843)",
    fill: "#ead6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M137.017,191.91c-.545,2.829-1,5.164-1.493,7.818,1.837-.663,3.424-1.2,4.976-1.79.64-.237.686-.734.285-1.238C139.6,195.178,138.4,193.675,137.017,191.91Z",
    transform: "translate(-51.554 -103.405)",
    fill: "#ead6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M153.223,189.016c-.64-4.016-1.363-8.032-2.073-12.037-.226-1.279-.531-2.547-.829-3.921-.854.285-1.592.545-2.334.769-1.754.531-3.494,1.1-5.284,1.54a58.583,58.583,0,0,1-11.671,1.646c-.817.025-1.137.354-1.208,1.174q-.479,6.189-1.061,12.356c-.083.8.366,1.908-.617,2.322-1.1.462-1.551-.663-2.143-1.316-3.958-4.371-9.111-3.873-12.842-.272-2.939,2.829-3.2,6.267-1.956,10,1.21,3.625,4.053,5.379,7.381,6.494a46.175,46.175,0,0,0,4.987,1.006c1.79.391,2.311,1.2,1.848,2.974-.638,2.4-1.339,4.8-2.085,7.167q-1.668,5.242-3.47,10.434a2.739,2.739,0,0,1-3.537,1.871c-.366-.071-.759-.071-1.114-.106-.106.189-.225.308-.212.414q.3,3.929.615,7.855c.06.663.6.817,1.126.913,1.22.237,2.44.485,3.673.651,3.777.545,7.546,1.079,11.318,1.576,2.274.3,4.561.58,6.847.782,1.316.118,1.374.025,1.415-1.238s.035-2.5,0-3.744c-.071-1.825-.189-3.65-.285-5.592-1.415.354-2.6.746-3.814.923a29.047,29.047,0,0,1-3.921.237c-.3,0-.58-.391-.884-.6.262-.331.439-.828.771-.958a4.543,4.543,0,0,1,1.563-.106,14.989,14.989,0,0,0,6.255-1.553,23.759,23.759,0,0,0,9.265-8.329,34.954,34.954,0,0,0,5.342-15.684,51.955,51.955,0,0,0-.129-10.237C154,193.945,153.627,191.467,153.223,189.016Z",
    transform: "translate(-70.782 -117.891)",
    fill: "#ead6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M102.707,258.97c-.414-.143-.64-.806-.958-1.22a96.557,96.557,0,0,0-8.554-9.019c-1.256,3.8-2.417,7.357-3.6,10.9a7.021,7.021,0,0,0,1.592,7.618c2.819,3.02,5.509,6.172,8.269,9.252a6.3,6.3,0,0,0,.923.746,4.289,4.289,0,0,0,.262-.628c1.006-5.024,2.025-10.046,3-15.07C103.809,260.581,104.152,259.479,102.707,258.97Z",
    transform: "translate(-87.236 -59.744)",
    fill: "#ead6c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(4.157 18.376)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M107.136,236.064l5.482,4.886L121.5,244.8l3.111,1.185,3.85.739,6.219-20.138-1.48-1.036-9.182-2.962-3.85-5.627V210.3l3.553-4.886,4.888-1.777,6.663,1.777,2.814,2.962.884-13.477a48.029,48.029,0,0,0,13.18-.884,53.482,53.482,0,0,0,9.477-3.111l-.592-2.665,13.921-7.848,9.328-6.366,8.738-8.886,4-7.995-1.482-4.888S176.881,172.689,168,176.984s-28.137,12-32.876,12.439-3.7,6.219-5.922,9.182-14.809,16.734-23.249,20.14l-8.442,3.406,4.6,8.441Z",
    transform: "translate(-84.923 -152.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M136.152,196.059l-1.629,2.962,8.292-4.147Z",
    transform: "translate(-56.48 -119.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M144.045,185.034l-.592-8-.884.3a31.006,31.006,0,0,1-1.036,10.81,20.17,20.17,0,0,1-5.183,9.1l-.148,4.52,3.852-2.962,3.257-5.776Z",
    transform: "translate(-55.192 -133.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M128.2,208.209a11.21,11.21,0,0,1-5.482.739,5.422,5.422,0,0,0,2.665,4c2.37,1.185,6.366,2.814,6.366,2.814l-.444-7.7,2.962-3.554a15.719,15.719,0,0,1-6.067,3.7Z",
    transform: "translate(-65.554 -112.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M152.108,214.848s-18.807,1.482-25.173,2.074a81.758,81.758,0,0,1-15.106-.592s18.51,12.732,25.175,13.617a33.887,33.887,0,0,0,12.883-1.036l-5.04-5.768,9.033-8.589Z",
    transform: "translate(-73.918 -104.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M99.573,298.23l1.036-1.185,12-57.9,4.444-15.549L96.315,270.689l-4.294-4.738-1.63,4.145s4,5.776,4,10.218-.3,11.551-.3,11.551Z",
    transform: "translate(-90.391 -97.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M255.049,206.853l-1.777-2.516s-.444,9.625-3.257,13.617-15.1,15.845-15.1,15.845l-33.025,63.973-7.4-6.517,5.7-6.886L181.155,299.7l-19.7-24.13s3.554,17.176,2.962,24.137-12.587,25.323-34.208,25.323-33.318-8.589-33.318-8.589l-3.21,18.708,94.973.987-8.294-29.419,3.825-4.936,15.031,8.884,2.814-.149,2.962-2.96,33.016-70.934,9.774-9.182,6.219-9.921,1.768-6.073Z",
    transform: "translate(-87.86 -112.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M176.967,224.183c2.271-.3,3.949-3.16,3.949-3.16l1.768-3.949,3.554-4.343,6.013-1.876,1.284.1a2.161,2.161,0,0,0,.884-2.476c-.394-1.777-8.1-4.145-8.1-4.145l3.061,4.244,1.678,1.482v.592l-5.233,1.579-2.368,2.764-11.355-.1-8.179-2.663-.3,2.368s.3,4.739,2.476,6.72S174.7,224.479,176.967,224.183Z",
    transform: "translate(-34.113 -112.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M171.075,222.425c.2-1.284-.691-1.381-2.665-1.876S163.471,216,163.471,216h-.394l4.244,8.195S170.877,223.708,171.075,222.425Z",
    transform: "translate(-34.539 -103.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(8.837 22.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M144.366,155.074c-3.22-2.122-7.185,1.31-9.549,3.31a63.088,63.088,0,0,0-9.875,11.565c-.847,1.165.318,2.587,1.526,2.653a7.663,7.663,0,0,0,2.829-.407,1.756,1.756,0,0,0,1.134-.11c4.513-2.076,9.7-4.734,12.987-8.6C145.287,161.292,147.526,157.159,144.366,155.074Z",
    transform: "translate(-68.745 -154.406)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M123.744,167.524a1.8,1.8,0,0,0-2-.812,6.749,6.749,0,0,0-1.569.55,2.428,2.428,0,0,0-2.347,2.359,2.631,2.631,0,0,0,2.111,2.52,3.424,3.424,0,0,0,3.8-4.617Z",
    transform: "translate(-73.986 -144.995)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M107.911,173.256a5.5,5.5,0,0,0-4.607,3.116,8.068,8.068,0,0,0-1.523,2.58c-.578,1.6-.927,4.165,1.07,4.907,1.768.658,3.949-.746,5.208-1.89a10.244,10.244,0,0,0,3.144-4.835,3.344,3.344,0,0,0-3.293-3.878Z",
    transform: "translate(-86.665 -139.922)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M119.425,183.139c-.027-.019-.039-.046-.067-.064-1.63-1.026-4.483.141-5.767,1.323-.539.5-1.261,1.388-.967,2.172.309.835,1.238.813,1.92.5a7.427,7.427,0,0,1,3.89-1.107,1.867,1.867,0,0,0,2.044-1.061C120.9,183.776,120.3,183.286,119.425,183.139Z",
    transform: "translate(-78.04 -132.679)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M113.187,186.683a1.475,1.475,0,0,0-.012-.354c-.205-.992-1.569-.723-1.706.131a1.132,1.132,0,0,0-.11.483.884.884,0,0,0,.649.852l.085.012a.905.905,0,0,0,1.088-.617l.016-.062a.851.851,0,0,0-.009-.446Z",
    transform: "translate(-78.96 -130.364)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M100.741,235.08c-1.592-.394-2.829,1.89-3.618,2.99a31.163,31.163,0,0,0-1.745,2.653c-2.028,2.851-3.551,5.912-1,6.179,1.91.2,3.586-2.057,4.421-3.461a15.638,15.638,0,0,0,2.6-7.505A.907.907,0,0,0,100.741,235.08Z",
    transform: "translate(-93.038 -92.452)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M100.281,232.3a.93.93,0,0,0-1.072.138l-.1.1c-.03.027-.037.057-.062.083a.837.837,0,0,0-.334.317,2.122,2.122,0,0,0-.3.753.9.9,0,0,0,.852,1.119C100.472,234.89,101.671,232.911,100.281,232.3Z",
    transform: "translate(-88.931 -94.634)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M143.072,232c-1.524-1.613-4.4-5.079-6.953-3.77-2.6,1.333-.214,4.043.707,5.6a18.149,18.149,0,0,0,3.947,5.581c1.839,1.912,3.724,2.624,4.937-.235C146.858,236.465,144.832,233.862,143.072,232Z",
    transform: "translate(-60.839 -97.902)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M145.477,237.609a2,2,0,0,0-2.272-.486.855.855,0,0,0-.511.21c-2,1.768,1.238,5.609,2.783,3.726a2.829,2.829,0,0,0,0-3.45Z",
    transform: "translate(-55.37 -90.975)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M165.859,233.468c-1.487-1.259-3.3.872-3.922,1.975-.492.865-.946,1.768-1.393,2.653a11.386,11.386,0,0,0-2.7,5.107c-.214,1.728.884,3.263,2.771,2.529,2.122-.826,3.673-4.278,4.5-6.181C165.666,238.269,167.319,234.7,165.859,233.468Z",
    transform: "translate(-43.262 -93.952)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M166.64,229.422a.9.9,0,0,0-1.119-.852l-.539.108a.736.736,0,0,0-1.107.332c-.462,1.019-.861,3.222.8,3.4C166.152,232.559,166.767,230.568,166.64,229.422Z",
    transform: "translate(-38.917 -97.44)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M181.332,210.462a3.2,3.2,0,0,0-2.875.794,4.221,4.221,0,0,0-2.739,3.335c-.071.513.214,1.176.852,1.119a3.415,3.415,0,0,0,2.382-1.592,2.476,2.476,0,0,1,.964-.8,5.8,5.8,0,0,0,1.367-.568C182.04,212.2,182.363,210.922,181.332,210.462Z",
    transform: "translate(-29.515 -111.39)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M182.617,204.29l-.193-.067a.84.84,0,0,0-.564-.608,2.578,2.578,0,0,0-1.684,0,.884.884,0,0,0,0,1.7l1.972.679C183.226,206.368,183.689,204.66,182.617,204.29Z",
    transform: "translate(-26.579 -116.703)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M169.06,217.139a4.613,4.613,0,0,1-1.945-1.1,1.957,1.957,0,0,0-1.531-.592.914.914,0,0,0-.852.649c-.258,1.273.884,1.889,2.064,2.272a2.14,2.14,0,0,0,2.267.479.884.884,0,0,0,0-1.7Z",
    transform: "translate(-37.977 -107.509)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M168.561,217.565v.11a.884.884,0,1,0,1.768,0v-.11a.884.884,0,0,0-1.768,0Z",
    transform: "translate(-35.006 -106.554)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M178.1,183.214c-3.254,0-6.5-.276-9.742-.5-1.135-.078-1.13,1.691,0,1.768,3.245.225,6.488.5,9.742.5a.884.884,0,0,0,0-1.768Z",
    transform: "translate(-35.813 -132.657)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M175.992,182.993h-.108a.884.884,0,0,0,0,1.768h.11a.884.884,0,1,0,0-1.768Z",
    transform: "translate(-30.058 -132.44)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M182.921,183.77q-1.708-.354-3.434-.61c-1.114-.163-1.592,1.54-.47,1.7s2.3.373,3.434.61C183.561,185.715,184.036,184,182.921,183.77Z",
    transform: "translate(-27.464 -132.32)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M260.874,258.479a17.861,17.861,0,0,1-2.829,9.691,39.529,39.529,0,0,1-6.136,7.937c-2.594,2.69-5.284,5.305-7.891,7.986a5.181,5.181,0,0,0-1.185,1.768c-2.854,8.135-6.989,15.7-10.61,23.491-3.89,8.387-7.629,16.848-11.549,25.223-2,4.276-4.244,8.435-6.4,12.641-1.415,2.737-2.854,5.482-4.3,8.2a14.494,14.494,0,0,1-1.089,1.634,4.918,4.918,0,0,1-6.421,1.825,50.325,50.325,0,0,1-8.637-4.679c-1.457-.884-2.844-1.883-4.276-2.829-1.031-.663-1.149-.628-1.979.249-2.2,2.37-2.156,2.357-1.28,5.224,1.185,3.89,2.311,7.8,3.413,11.694s2.168,7.843,3.245,11.763c.274,1.006.582,2,.819,3.033.248,1.089.023,1.351-1.21,1.351-1.848-.012-3.684-.118-5.532-.131q-12.922-.053-25.863-.1c-4.608-.023-9.2-.141-13.813-.129-7.109.023-14.216.2-21.313.189-8.957-.025-17.9-.166-26.844-.26a8.571,8.571,0,0,1-.983-.037c-.96-.118-1.339-.53-1.2-1.415.308-1.8.676-3.59,1.019-5.392.557-3.033,1.126-6.066,1.682-9.1.332-1.74.63-3.494,1.008-5.224a2.219,2.219,0,0,0-.817-2.453,79.694,79.694,0,0,1-10.674-12.106,5.606,5.606,0,0,1-.96-5.047c.806-2.559,1.5-5.153,2.274-7.724.557-1.883,1.114-3.779,1.768-5.627a1.427,1.427,0,0,0-.3-1.592,17.188,17.188,0,0,1-1.729-2.38,2.868,2.868,0,0,1-.141-3.006c.426-.8.828-1.634,1.3-2.416,6.138-10.248,12.144-20.579,18.955-30.4,3.1-4.478,6.161-8.991,9.242-13.48.509-.746,1.029-1.482,1.516-2.241a10.246,10.246,0,0,0,.829-7.781,5.129,5.129,0,0,1,.2-3.459,1.215,1.215,0,0,1,1.339-.842c.723.048,1.445.1,2.156.214,1.682.285,3.36.6,5.284.948,0-.707.035-1.22,0-1.742-.141-2.156-.343-4.324-.451-6.479a1.238,1.238,0,0,0-.948-1.293c-.935-.308-1.823-.722-2.748-1.061a40.61,40.61,0,0,1-17.58-13.516,35.946,35.946,0,0,1-6.481-14.833,33.98,33.98,0,0,1-.568-10.994,27.668,27.668,0,0,1,6.563-16.359,22.338,22.338,0,0,1,16.041-7.781,36.982,36.982,0,0,1,4.727.012,4.635,4.635,0,0,0,3.257-.971,125.519,125.519,0,0,0,29.783-29.014c2.808-3.8,5.567-7.629,8.387-11.433a14.835,14.835,0,0,1,9.1-6.1,11.608,11.608,0,0,1,3.714-.2,5.618,5.618,0,0,1,4.81,4.135c.354,1.091.509,2.264.759,3.413,6.255-2.642,12.083,2.405,9.2,9.7.865-.071,1.694-.212,2.536-.212a3.312,3.312,0,0,1,3.714,3.447,11.684,11.684,0,0,1-1.362,6.456,42.324,42.324,0,0,1-9.337,11.611,86.454,86.454,0,0,1-23.681,15.353c-.829.366-1.185.707-.884,1.742a42.136,42.136,0,0,1,.884,5.035,1.248,1.248,0,0,0,1.469,1.238c.913-.083,1.823-.191,2.736-.249,1.646-.1,3.282-.214,4.929-.225,1.528-.012,2.027.378,2.334,1.848a19.6,19.6,0,0,1,.343,3.328,37.313,37.313,0,0,1-.707,9.809,18.893,18.893,0,0,1-5.685,9.714c-1.126,1.043-1.149,1.031-.237,2.18.936,1.185,1.906,2.347,2.829,3.537a5.834,5.834,0,0,1,.794,1.351c.5,1.268.272,2.014-.973,2.584a36.9,36.9,0,0,1-4.762,1.836,4.166,4.166,0,0,0-3.068,2.653,27.829,27.829,0,0,1-10.556,12.909,2.078,2.078,0,0,0-1.1,1.906c.1,2.891.166,5.793.237,8.685.035,1.883.048,1.919,2.014,2.1,1.563.129,3.151.164,4.727.272,2.085.141,4.193.248,6.278.462,1.316.131,1.754,1.125,1.043,2.239a5.052,5.052,0,0,1-.782.884c-2.228,2.226-4.442,4.465-6.693,6.669-1.061,1.031-1.482,1.019-.025,2.37,12.085,11.318,23.7,23.1,35.256,34.949.5.531,1.008,1.042,1.5,1.563a.555.555,0,0,0,.971-.094c.653-.983,1.328-1.956,1.908-2.975q8.778-15.512,17.557-31.014a3.65,3.65,0,0,0,.249-3.827c-1.374-2.75-2.488-5.639-3.89-8.387a30.261,30.261,0,0,1-3.105-9.9,10.687,10.687,0,0,1,1.5-6.623,17.872,17.872,0,0,1,3.685-5.07,3.452,3.452,0,0,0,.948-2.511c.545-5.7,1.019-11.4,1.576-17.084a90.223,90.223,0,0,1,2.108-12.817,4.619,4.619,0,0,1,5.165-4.1,90.959,90.959,0,0,1,13.2.616c2.925.416,5.864.759,8.778,1.22A5.249,5.249,0,0,1,258,220.229a77.793,77.793,0,0,1-.023,8.471c-.154,3.873-.474,7.747-.707,11.609-.164,2.962-.26,5.912-.462,8.861a2.327,2.327,0,0,0,.884,2.2,9.123,9.123,0,0,1,3.18,7.105Zm-4.028,8.269a15.585,15.585,0,0,0,2.311-8.435,7.349,7.349,0,0,0-2.677-5.71,11.7,11.7,0,0,0-9.466-2.322,1.692,1.692,0,0,0-1.54,2.4,3.767,3.767,0,0,0,.884,1.493,14.37,14.37,0,0,0,4.6,3.328,5.46,5.46,0,0,1,1.339.806,1.415,1.415,0,0,1,.237,1.061c-.048.2-.474.391-.759.451-.378.094-.794,0-1.172.071a18.389,18.389,0,0,0-3.638.769,11.848,11.848,0,0,0-6.776,7.958c-.177.569-.3,1.149-.474,1.706-.141.5-.509.913-.983.663a1.356,1.356,0,0,1-.509-1.089c.071-2.11.1-2.11-1.908-2.228-.531-.035-1.061,0-1.576-.046-2.95-.272-5.91-.416-8.824-.865-3.756-.569-5.142-2.44-4.881-6.257.141-2.025.391-4.051.555-6.076.083-.884.108-1.742.156-2.607-.143-.048-.285-.083-.416-.131-.782,1.185-1.623,2.347-2.334,3.567a9.466,9.466,0,0,0-1.172,6.076,25.773,25.773,0,0,0,2.309,7.689c1.659,3.565,3.247,7.167,4.918,10.722a3.022,3.022,0,0,1-.166,2.985c-1.061,1.883-2.062,3.814-3.116,5.7-3.933,7.049-7.855,14.1-11.848,21.111-1.848,3.247-3.852,6.41-5.783,9.62,1.316,1.517,2.607,3.006,3.91,4.479,2.31,2.617,2.322,2.688.262,5.482-.118.164-.237.318-.354.485a135.44,135.44,0,0,1-15.829,17.261c-.8.734-1.528,1.576-2.31,2.382a3.908,3.908,0,0,0,.509.53c3.164,2,6.315,4,9.514,5.959a18.812,18.812,0,0,0,3.006,1.432,3.537,3.537,0,0,0,4.929-1.5,17.513,17.513,0,0,0,.935-1.5c1.457-2.785,2.927-5.569,4.348-8.365,2.156-4.218,4.384-8.4,6.366-12.676,3.91-8.387,7.618-16.87,11.539-25.246,3.537-7.535,7.535-14.869,10.283-22.757a5.542,5.542,0,0,1,1.238-1.966c2.463-2.548,5-5.036,7.486-7.56a39.966,39.966,0,0,0,6.884-8.847Zm-.935-33.267c.141-4.453,1.061-8.884.32-13.362-.378-2.347-1.019-3.378-3.33-3.733-4.407-.663-8.842-1.256-13.279-1.646a79.212,79.212,0,0,0-8.861-.154c-2.11.035-2.631.531-3.151,2.524a74.672,74.672,0,0,0-2.3,14.559c-.035.653-.071,1.3-.142,1.956-.32,2.879-.688,5.733-.973,8.612-.249,2.548-.414,5.107-.592,7.654-.272,3.8-.58,7.593-.759,11.408-.106,2.264.5,2.962,2.7,3.59.189.06.391.071.58.118a62.464,62.464,0,0,0,12.156,1.043c1.077.011,1.326-.6,1.682-1.719-2.44-.129-4.656-.225-6.872-.378-2.085-.154-4.193-.249-6.255-.592-1.752-.3-2.037-.771-2-2.571.035-1.966.2-3.933.32-5.9.249-4,.426-8.009.769-12,.569-6.543,1.238-13.086,1.873-19.608.141-1.432.343-2.879.615-4.288a2.539,2.539,0,0,1,2.829-2.4c2.168-.035,4.348-.035,6.517,0,1.836.025,1.979.166,2.5,2.039a3.02,3.02,0,0,0,.166.568c.345.653.759,1.28,1.592,1.291a1.933,1.933,0,0,0,1.74-1.089,6.171,6.171,0,0,0,.38-.913c.52-1.374.651-1.48,2.143-1.326,1.768.177,3.519.378,5.284.592.451.058.9.177,1.351.272a1.821,1.821,0,0,1,1.493,1.623,8.061,8.061,0,0,1,.035,1.777c-.225,3.471-.462,6.941-.688,10.412-.058.983-.035,1.979-.106,2.962q-.479,6.38-.983,12.759c-.071.829.106,1.415,1.043,1.563a9.368,9.368,0,0,1,1.172.354c.154-2.122.308-4.135.439-6.159.223-3.28.485-6.55.591-9.832Zm-3.247-12.676c.048-.913-.308-1.268-1.238-1.326-1.434-.083-2.867-.285-4.3-.462-.865-.108-1.415-.012-1.742,1.042a3.349,3.349,0,0,1-3.222,2.18,3.281,3.281,0,0,1-3.056-1.825,3.628,3.628,0,0,1-.569-1.256c-.129-.794-.64-.852-1.268-.842-1.906.012-3.814-.023-5.721.025-1.2.023-1.339.154-1.482,1.362-.545,4.822-1.112,9.643-1.592,14.478-.343,3.517-.58,7.059-.842,10.591-.366,4.785-.734,9.56-1.042,14.335-.166,2.653.058,2.829,2.771,3,.131.011.262.011.391.023,2.228.106,4.455.237,6.693.332,1.376.058,2.76.106,4.136.071a2.069,2.069,0,0,0,1.385-.474,12.522,12.522,0,0,1,6.529-3.767c-.628-.486-.983-.736-1.316-1.02a10.391,10.391,0,0,1-3.34-3.79,3.236,3.236,0,0,1,1.823-4.525,12.445,12.445,0,0,1,3.448-.592c1.9-.119,1.9-.048,2.085-1.979.023-.2.012-.4.023-.592.3-4.787.569-9.572.865-14.359.083-1.238.237-2.486.3-3.731.106-2.3.164-4.6.283-6.9Zm-45.22,106.576a1.445,1.445,0,0,0-.154-2.062c-1.848-1.966-3.577-4.028-5.438-5.982-11.751-12.393-23.873-24.429-36.215-36.217-.96-.913-1.979-1.729-2.95-2.617-.782-.707-.794-1.043-.143-1.8.214-.248.474-.449.707-.674,1.956-1.85,3.935-3.673,5.864-5.546.653-.615,1.2-1.339,1.79-2-.071-.141-.131-.3-.2-.439-.769-.048-1.551-.106-2.322-.166-2.748-.177-5.521-.26-8.257-.545-5.616-.592-11.219-1.326-16.835-1.931s-11.123-1.823-16.692-2.76c-2.914-.485-3.537-.935-2.808,2.844a10.266,10.266,0,0,1-.4,6.517c-2.262,4.974-3.114,10.412-4.571,15.638-1.85,6.623-3.425,13.327-5.047,20.009-1.592,6.543-3.141,13.127-4.6,19.712-1.279,5.818-2.416,11.682-3.588,17.521-.937,4.633-1.873,9.254-2.737,13.9-1.238,6.633-2.405,13.279-3.613,19.914-.285,1.563-.3,1.623,1.415,1.671,4.336.141,8.665.308,13.008.32q25.96.053,51.913.011c2.76,0,5.532,0,8.292.012,5.463.035,10.911.1,16.372.106,1.565.012,1.636-.118,1.238-1.563-1.592-5.746-3.151-11.495-4.762-17.237-.746-2.642-1.576-5.261-2.428-8.092-.6.531-.973.884-1.374,1.2-1.079.852-1.592.757-2.357-.451a5.089,5.089,0,0,1-.249-.531,215.4,215.4,0,0,1-9.988-20.485c-1.694-3.837-3.36-7.687-5.045-11.526-.249-.557-.522-1.149.189-1.516s1.089.129,1.362.721c.439.948.912,1.885,1.316,2.856,3.436,8.292,7.12,16.49,11.141,24.522.769,1.565,1.682,3.068,2.653,4.8.568-.638.948-1.061,1.326-1.48,2.653-2.9,5.141-5.97,7.984-8.665a169.2,169.2,0,0,0,13.588-14.536C205.744,329.733,206.591,328.553,207.444,327.381Zm-4.394-162.836c.214-1.28.354-2.642-.686-3.484a3.22,3.22,0,0,0-3.537.118c-.817.4-1.634.829-2.451,1.238-.557.274-1.185.451-1.623-.106-.4-.545.035-1.019.426-1.362a8.743,8.743,0,0,0,2.264-4.929,4.674,4.674,0,0,0-5.947-5.332c-.913.354-1.754.884-2.667,1.238a2.087,2.087,0,0,1-1.415.189c-.58-.237-.368-.806-.2-1.363a6.366,6.366,0,0,0-.935-5.448,3.132,3.132,0,0,0-2.559-1.636,16.461,16.461,0,0,0-3.89.285,12.6,12.6,0,0,0-7.286,5.07c-2.665,3.567-5.284,7.18-7.914,10.787a128.7,128.7,0,0,1-31.762,30.874,3.119,3.119,0,0,1-1.945.707,25.98,25.98,0,0,0-7.25.048,20.915,20.915,0,0,0-14.725,8.529,26.666,26.666,0,0,0-4.893,12.925,34.659,34.659,0,0,0,.378,11.171A32.892,32.892,0,0,0,109,236.126,38.264,38.264,0,0,0,122.164,248.9a42.5,42.5,0,0,0,11.848,4.692c.806.177,1.256.011,1.47-.806.094-.378.3-.723.414-1.1.96-2.854,1.956-5.7,2.867-8.564.783-2.44,1.482-4.906,2.193-7.358.32-1.089.2-1.22-.925-1.415a35.649,35.649,0,0,1-4.067-.734c-5.128-1.553-8.743-4.5-9.749-10.165a10.331,10.331,0,0,1,1.989-8.311,10.453,10.453,0,0,1,14.193-2.7c.58.4,1.149.817,1.966,1.4.141-1.256.272-2.274.354-3.293.225-3.006.416-6.03.653-9.04a1.995,1.995,0,0,1,2.025-2.156c2.027-.2,4.051-.439,6.078-.628A51.612,51.612,0,0,0,169.7,194.2a82.615,82.615,0,0,0,22.165-14.1,48.2,48.2,0,0,0,7.3-7.7,19.1,19.1,0,0,0,3.883-7.857Zm-22.812,50.94a88.6,88.6,0,0,0,.071-8.861c-.011-1.415-.141-1.516-1.669-1.493-2.168.048-4.336.166-6.5.285-1.162.058-1.149.1-.936,1.3a109.54,109.54,0,0,1,2.143,17.557c.012.96.1,1.919.166,3.222a14.168,14.168,0,0,0,1.634-1.185,17.422,17.422,0,0,0,5.1-10.828Zm-3.257,20.91c.64-.237.686-.734.285-1.238-1.185-1.517-2.382-3.02-3.768-4.785-.545,2.829-1,5.164-1.493,7.818,1.844-.668,3.431-1.2,4.983-1.795Zm-5.415-5.756a51.957,51.957,0,0,0-.129-10.237c-.177-2.486-.557-4.964-.96-7.415-.64-4.016-1.363-8.032-2.073-12.037-.226-1.279-.531-2.547-.829-3.921-.854.285-1.592.545-2.334.769-1.754.531-3.494,1.1-5.284,1.54a58.583,58.583,0,0,1-11.671,1.646c-.817.025-1.137.354-1.208,1.174q-.479,6.189-1.061,12.356c-.083.8.366,1.908-.617,2.322-1.1.462-1.551-.663-2.143-1.316-3.958-4.371-9.111-3.873-12.842-.272-2.939,2.829-3.2,6.267-1.956,10,1.21,3.625,4.053,5.379,7.381,6.494a46.17,46.17,0,0,0,4.987,1.006c1.79.391,2.311,1.2,1.848,2.974-.638,2.4-1.339,4.8-2.085,7.167q-1.668,5.242-3.47,10.434a2.739,2.739,0,0,1-3.537,1.871c-.366-.071-.759-.071-1.114-.106-.106.189-.225.308-.212.414q.3,3.929.615,7.855c.06.663.6.817,1.126.913,1.22.237,2.44.485,3.673.651,3.777.545,7.546,1.079,11.318,1.576,2.274.3,4.561.58,6.847.782,1.316.118,1.374.025,1.415-1.238s.035-2.5,0-3.744c-.071-1.825-.189-3.65-.285-5.592-1.415.354-2.6.746-3.814.923a29.047,29.047,0,0,1-3.921.237c-.3,0-.58-.391-.884-.6.262-.331.439-.828.771-.958a4.543,4.543,0,0,1,1.563-.106,14.988,14.988,0,0,0,6.255-1.553,23.759,23.759,0,0,0,9.265-8.329,34.954,34.954,0,0,0,5.372-15.673ZM119.02,281.456a29.018,29.018,0,0,0-2.382,3.1c-3.8,5.592-7.724,11.1-11.35,16.8-4.311,6.741-8.375,13.648-12.522,20.5-1.729,2.854-1.717,3.091.6,5.6,3.684,4.016,7.415,7.984,11.141,11.965a3.909,3.909,0,0,0,.686.332C108.985,320.007,114.1,300.76,119.02,281.456Zm-14.584,62.207c.177-.958.52-2.06-.925-2.569-.414-.143-.64-.806-.958-1.22A96.56,96.56,0,0,0,94,330.854c-1.256,3.8-2.417,7.357-3.6,10.9a7.02,7.02,0,0,0,1.592,7.618c2.819,3.02,5.509,6.172,8.269,9.252a6.3,6.3,0,0,0,.923.746,4.3,4.3,0,0,0,.262-.628c1-5.038,2.021-10.06,2.994-15.084Z",
    transform: "translate(-88.04 -141.862)",
    fill: "#3c3372"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIls1);
export default __webpack_public_path__ + "static/media/feature-ils-1.492c538c664edc9d4444ed2c0176722c.svg";
export { ForwardRef as ReactComponent };